import { render } from "./IconDevices.vue?vue&type=template&id=725e6a1e"
import script from "./IconDevices.vue?vue&type=script&lang=js"
export * from "./IconDevices.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__